class ExploreResourcesBlock extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this._init();
    }

    async _init() {
        await customElements.whenDefined('resource-center');

        const $rc = document.querySelector('resource-center');
        const $links = Array.from(this.querySelectorAll('.link:not(.external-link)'));

        if ($rc && $links) {
            $links.forEach($link => $link.addEventListener('click', (e) => {
                $rc.onExploreClick(e);
            }));
        }
    }
}

customElements.define('explore-resources-block', ExploreResourcesBlock);